<div *ngIf="loading"
     class="loading-overlay">
  <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
  <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div class="row animated fadeIn fast">
  <div class="col-12">
    <div class="card border rounded animated fadeIn fast">

      <div class="card-body">

        <!-- cabecera -->
        <div class="row mb-2">

          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <input class="form-control"
                     type="text"
                     id="buscaTodo"
                     autofocus
                     placeholder="Buscar cualquier dato..."
                     [(ngModel)]="strBuscarTodo"
                     (keyup)="buscarTodo($event)" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        title="Limpiar búsqueda"
                        (click)="limpiaBusca()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
              <select class="form-control"
                      [(ngModel)]="clienteSeleccionadoId"
                      (ngModelChange)="onClienteSelect()"
                      title="Clientes">
                <option value=0>Todos los clientes...</option>
                <option *ngFor="let cliente of clientesList"
                        [value]="cliente.id">
                  {{cliente.nombre}}
                </option>
              </select>
            </div>
          </div>

          <div class="col-3">
            <div class="input-group border border-dark rounded">
              <div class="input-group-addon"><i class="fa fa-barcode"></i></div>
              <select class="form-control"
                      [(ngModel)]="articuloSeleccionadoId"
                      (ngModelChange)="onArticuloSelect()"
                      title="Artículo">
                <option value=0>Todos los artículos con gestión de lotes...</option>
                <option *ngFor="let articulo of articulosList"
                        [value]="articulo.id">
                  {{articulo.descripcion}}
                </option>
              </select>
            </div>
          </div>

          <div class="col-3">
            <form>

              <div class="row float-right">
                <div class="col-sm-7">
                  <div class="form-group rounded">
                    <select class="form-control"
                            name="rowsLimitStr"
                            [(ngModel)]="rowsLimitStr"
                            (change)="rowsLimitChange()">
                      <option [value]="10">10</option>
                      <option [value]="50">50</option>
                      <option [value]="100">100</option>
                      <option [value]="999999">Todo</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group float-right">
                    <div class="btn-group">
                      <button type="button"
                              (click)="getTrazaLotes()"
                              class="btn btn-outline-info btn-circle"
                              title="Recargar datos">
                        <i class="fa-solid fa-sync"></i>
                      </button>
                      <button type="button"
                              (click)="exportToExcel()"
                              class="btn btn-outline-info btn-circle"
                              title="Descargar Excel">
                        <i class="fa-solid fa-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>


            </form>
          </div>

        </div>



        <div class="rounded border">
          <!-- datatable -->
          <ngx-datatable class='bootstrap'
                         [style.width]="'100%'"
                         [columns]="columns"
                         [columnMode]="'force'"
                         [loadingIndicator]="loading"
                         [headerHeight]="70"
                         [footerHeight]="50"
                         [rowHeight]="50"
                         [limit]="rowsLimit"
                         [rows]='rows'
                         [messages]="messages"
                         [summaryRow]="true"
                         [summaryHeight]="50"
                         [summaryPosition]="summaryPosition">




            <!-- cliente.nombre -->
            <ngx-datatable-column name=""
                                  prop="cliente.nombre"
                                  [flexGrow]="15"
                                  [resizeable]="true">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">Cliente</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- camp_cod -->
            <ngx-datatable-column name="camp_cod"
                                  prop="camp_cod"
                                  [width]="1"
                                  [maxWidth]="150"
                                  [resizeable]="true">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">Campaña</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- id_pedido -->
            <ngx-datatable-column name="Id Ped"
                                  prop='id_pedido'
                                  [width]="1"
                                  [maxWidth]="50"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">id_pedido</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- pedido_cli -->
            <ngx-datatable-column name="pedido_cli"
                                  prop="pedido.pedido_cli"
                                  [flexGrow]="15"
                                  [resizeable]="true">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">Pedido</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- id_articulo -->
            <ngx-datatable-column name="id_articulo"
                                  prop="articulo.id"
                                  [width]="1"
                                  [maxWidth]="65"
                                  [resizeable]="false">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <div class="header noSearch"
                     (click)="sort()">
                  <h6 class="title link">Id art.</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- foto -->
            <ngx-datatable-column name=''
                                  prop="articulo.foto"
                                  [width]="1"
                                  [maxWidth]="50"
                                  [resizeable]="false"
                                  [sortable]="false">

              <ng-template ngx-datatable-cell-template
                           let-value="value">

                <div *ngIf="value">
                  <img [src]="fotoDir +'/articulos' + imgResized + value"
                       loading="lazy"
                       alt="Foto"
                       class="rounded pointer border"
                       height="25px"
                       (click)="abrirPopupImagen(fotoDir + '/articulos' + '/' + value)">
                </div>

              </ng-template>
            </ngx-datatable-column>





            <!-- sku -->
            <ngx-datatable-column name=""
                                  prop="articulo.sku"
                                  [flexGrow]="15">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'sku')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">SKU</h6>
                </div>
              </ng-template>

              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global">
                  <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                  <span *ngIf="row.swDefectuoso == Constantes.DEFECTUOSO"
                        class="text-warning ml-12">
                    <i title="Defectuoso"
                       class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                  </span>
                </div>

              </ng-template>
            </ngx-datatable-column>



            <!-- ean -->
            <ngx-datatable-column name=""
                                  prop="articulo.ean"
                                  [flexGrow]="15">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'ean')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link"><i class="fa fa-barcode"></i> Ean</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>



            <!-- descripcion -->
            <ngx-datatable-column name=""
                                  prop="articulo.descripcion"
                                  [flexGrow]="15">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'descripcion')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Descripción</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>

                <span *ngIf="row.url">
                  <a href="{{row.url}}"
                     target="_blank"
                     title="Abrir {{row.url}}">
                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                  </a>
                </span>

                <div *ngIf="!row.url"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>

              </ng-template>

            </ngx-datatable-column>




            <!-- lote -->
            <ngx-datatable-column name="lote"
                                  [flexGrow]="15">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <input type="search"
                       class="form-control form-control-sm"
                       placeholder="Buscar..."
                       (keyup)="buscar($event, 'lote')"><br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link">Lote</h6>
                </div>
              </ng-template>
              <ng-template let-value="value"
                           let-row="row"
                           ngx-datatable-cell-template>

                <span *ngIf="row.url">
                  <a href="{{row.url}}"
                     target="_blank"
                     title="Abrir {{row.url}}">
                    <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                  </a>
                </span>

                <div *ngIf="!row.url"
                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>

              </ng-template>

            </ngx-datatable-column>




            <!-- cant_repartida -->
            <ngx-datatable-column name=""
                                  prop="cant_repartida"
                                  [cellClass]="'text-right'"
                                  [flexGrow]="85"
                                  [cellClass]="'text-right'"
                                  [summaryFunc]="sumaCeldas">
              <ng-template ngx-datatable-header-template
                           let-sort="sortFn"
                           let-column="column">
                <br>
                <div class="header"
                     (click)="sort()">
                  <h6 class="title link mt-12"
                      title="Volumen en m3">Cantidad</h6>
                </div>
              </ng-template>

              <ng-template let-value="value"
                           ngx-datatable-cell-template>
                <div (dblclick)="dblclickCampo(value)"
                     title="Doble click para busqueda global"
                     [innerHTML]="funcLib.resaltarTexto(value | number: '0.0-0':'es', textoDestacado)"></div>
              </ng-template>
            </ngx-datatable-column>


          </ngx-datatable>
        </div>

      </div>
    </div>
  </div>



  <!-- Modal para mostrar la imagen -->
  <div class="modal-overlay"
       *ngIf="imagenSeleccionada"
       (click)="cerrarPopupImagen()">
    <div class="modal-content">
      <img [src]="imagenSeleccionada"
           class="modal-image"
           alt="Imagen seleccionada">
    </div>
  </div>



</div>